import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getAgent} from '../../../../../selectors'
import type {AgentId} from '../../../../../types'

import AgentLine from './AgentLine'

type Props = {
  agentId: AgentId
}

const mapStateToProps = (state: State, props: Props) => {
  const {connected, authorized, lastActivityTime, disconnectionComment} =
    getAgent(state, props.agentId) || {}
  return {
    isConnected: connected,
    isAuthorized: authorized,
    lastActivityTime,
    disconnectionComment,
  }
}

export default connect(mapStateToProps)(AgentLine)
